import { EU_MEMBER_STATES } from '~/utils/euMemberStates';

const getRegion = (locale: Locale, country: string | undefined): string => {
  if (locale !== 'en') return 'eur';

  const upper = country?.toUpperCase();
  if (upper === 'US') return 'int';
  if (upper === 'GB' || (upper != null && EU_MEMBER_STATES.has(upper))) {
    return 'eur';
  }
  return 'int';
};

export default () => {
  const i18n = useI18n();
  const authStore = useAuthStore();
  const userCountry = useUserCountry();
  const region = computed(() => {
    if (authStore.activeRegion != null) {
      return authStore.activeRegion.toLowerCase();
    }

    return getRegion(i18n.locale.value, userCountry.value);
  });

  return { region };
};
